/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_DownloadedInputs */



/**
* | output |
* | --- |
* | "Preview downloaded successfully" |
*
* @param {Image_Export_Preview_DownloadedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_downloaded = /** @type {((inputs?: Image_Export_Preview_DownloadedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_DownloadedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Previsualisation telechargee avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorschau erfolgreich heruntergeladen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anteprima scaricata correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Предварительная версия успешно загружена.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista previa descargada exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预览版下载成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレビューが正常にダウンロードされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्वावलोकन सफलतापूर्वक डाउनलोड हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pré-visualização baixada com sucesso.")
	return /** @type {LocalizedString} */ ("Preview downloaded successfully")
});